export const moveItem = (originalArray, fromIndex, toIndex) => {
  let newArray = [...originalArray];
  if (toIndex == fromIndex || toIndex < 0 || toIndex >= originalArray.length)
    return newArray;

  let target = newArray[fromIndex];
  let inc = toIndex < fromIndex ? -1 : 1;

  for (let i = fromIndex; i != toIndex; i += inc) {
    newArray[i] = newArray[i + inc];
  }

  newArray[toIndex] = target;
  return newArray;
};
